<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="product/brand/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="BrandForm"
        >
          <template #header-btns>
            <button
                @click="goToProductPage(item.id)"
                v-if="item.id"
                class=" float-left px-2 text-white py-1 rounded-lg text-[8px] font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-blue-800 via-blue-900 to-blue-700 hover:bg-[#F17359]"        >
              مشاهده محصولات
            </button>
          </template>

          <template>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-img
                    @click="change_logo_dialog = true"
                    class="mr-2"
                    style="cursor: pointer"
                    v-if="!item.logo"
                    contain
                    max-height="90"
                    max-width="90"
                    src="/img/icons/photo.svg"
                />
                <v-avatar class="mr-2" v-if="item.logo" size="100" style="cursor: pointer"
                          @click="change_logo_dialog = true">
                  <v-img class="rounded-lg" :src="img_source(item.logo)" />
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="* نام برند "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <supplier-select
                    class="rounded-lg"
                    label="تامین کننده"
                    v-model="item.supplier"
                    :disabled="!isEditing"
                >
                </supplier-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-switch
                    inset
                    background-color=""
                    color="primary"
                    v-model="item.is_domestic"
                    label='تولید داخل'
                    :disabled="!isEditing"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="کشور تولید " v-if="!item.is_domestic"
                              v-model="item.made_in" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
                <v-text-field label="کشور تولید " v-else
                              v-model="item.made_in = 'ایران'" background-color="white" class="rounded-lg"
                              :disabled="true"/>
              </v-col>
            </v-row>

          </template>
        </m-form>
        <v-row justify="center">
          <v-dialog
              v-model="change_logo_dialog"
              class="rounded-lg"
              persistent
              @click:outside="change_logo_dialog=false"
              max-width="400"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                تغییر لوگو برند
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <m-file-input
                        label="انتخاب لوگو"
                        v-model="logo"
                        :delete-attachment.sync="delete_logo"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="change_logo_dialog = false"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="updateLogo(item)"
                >
                  تغییر لوگو
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import SupplierSelect from "@/components/selects/SupplierSelect";


export default {
  name: "Brand",
  components: {SupplierSelect},
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'product/brand/all',
      baseUrl: "product/brand",
      permissionBasename: "brand",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      delete_logo: null,
      logo: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      change_logo_dialog: false,
      suppliers: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام برند",
          value: "name",
        },
        {
          text: "داخلی",
          value: "is_domestic",
          type: 'boolean'
        },
        {
          text: "کشور تولید",
          value: "made_in",
        },
      ],

    };
  },
  computed: {
    title(){
      return 'برند محصول'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
    this.getSuppliers()
  },
  methods: {
    getUpdateLogoSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        logo: this.logo,
        delete_logo: this.delete_logo,
      };

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },
    goToProductPage(id) {
      this.$router.push(`/panel/adminProductList?brand=${id}`)
    },

    updateLogo(selectItem) {
      this.request({
        url: this.endpoint(`product/brandsLogoUpdate/${selectItem.id}`),
        method: "put",
        data: this.getUpdateLogoSerialized(selectItem),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          this.change_logo_dialog = false
          this.$refs.BrandForm.$refs.datatable.getDataFromApi()
          this.setItem(data)
        },
      });
    },

    getSuppliers() {
      this.request({
        url: this.endpoint(`main/supplier`),
        method: "get",
        success: data => {
          this.suppliers = []
          for (let supplier of data) {
            this.suppliers.push({
              'name': supplier.name ,
              'id': supplier.id,
            })
          }
        }
      })
    }

  },
}
</script>

<style scoped lang="scss"></style>

